import { apiSelector } from '@ackee/redux-utils';

import type { AppState } from '@/types';

export const selectUpdateTagApi = (state: AppState, tag: string) => apiSelector(state, 'tags', 'update', tag);
export const selectRemoveTagApi = (state: AppState, tag: string) => apiSelector(state, 'tags', 'remove', tag);
